/**
 * Lightweight install-funnel tracker.
 * Fire-and-forget — never throws, never blocks the UI.
 */

const API = process.env.REACT_APP_BACKEND_URL;
const TRACKED_KEY = 'ds_install_tracked_v1';

const detectDevice = () => {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'desktop';
};

const isStandaloneMode = () => {
  try {
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
    if (window.navigator && window.navigator.standalone === true) return true; // iOS Safari
  } catch {}
  return false;
};

export const trackInstallEvent = (eventType, { page, teamId } = {}) => {
  try {
    fetch(`${API}/api/analytics/install-track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page: page || null,
        team_id: teamId || null,
        device: detectDevice(),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
};

/**
 * Detect already-installed PWAs that we missed via the native `appinstalled` event.
 * iOS Safari NEVER fires `appinstalled` for "Add to Home Screen", so without this
 * detection iOS installs are invisible in analytics.
 * Fires once per device via localStorage flag.
 */
export const detectAndTrackInstall = () => {
  try {
    if (!isStandaloneMode()) return;
    if (localStorage.getItem(TRACKED_KEY)) return;
    localStorage.setItem(TRACKED_KEY, new Date().toISOString());
    trackInstallEvent('install', { page: 'standalone_detected' });
  } catch {}
};
